import React from 'react'
import LeftSidebar from './Tabs/leftSidebar'
import Profile from './Tabs/Profile'

const ProfileSetting = () => {
  return (
    <div className='mainSettingprofile'>
        <div className='sidebarleft'>
            <LeftSidebar />
        </div>
        <div className='sidebarright'>
<Profile/>

        </div>
    </div>
  )
}

export default ProfileSetting